var _rect, _path, _path2, _text, _path3, _path4, _image, _path5, _path6, _rect2, _text2, _path7, _path8, _text3, _path9, _path10, _path11, _path12, _ellipse, _g, _path13, _path14, _path15, _path16, _ellipse2, _g2, _path17, _path18, _path19, _path20, _ellipse3, _g3, _path21, _path22, _ellipse4, _g4, _path23, _path24, _image2, _path25, _path26, _image3, _path27, _path28, _text4, _path29, _path30, _text5, _path31, _path32, _text6, _text7, _text8, _text9, _text10, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontEndDevOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "756px",
    height: "651px",
    viewBox: "-0.5 -0.5 756 651",
    content: "<mxfile host=\"Electron\" modified=\"2022-03-17T01:53:21.532Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"uxyNOWxzd_hvRBAzFPKY\" version=\"16.5.1\" type=\"device\"><diagram id=\"qHnaU109PntuK9qI-dVp\" name=\"Page-1\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-60a337-1-277116-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(39, 113, 22)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(96, 163, 55)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280,
    width: 755,
    height: 370,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 755 0 L 755 260 L 0 260 Z",
    fill: "none",
    stroke: "#232f3e",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.09 7.18 C 6.01 7.18 5.93 7.19 5.85 7.19 C 5.5 7.19 5.15 7.23 4.81 7.32 C 4.53 7.39 4.25 7.49 3.98 7.62 C 3.9 7.65 3.84 7.7 3.79 7.76 C 3.75 7.83 3.74 7.91 3.74 7.99 L 3.74 8.32 C 3.74 8.46 3.79 8.53 3.89 8.53 L 3.99 8.53 L 4.22 8.44 C 4.45 8.35 4.69 8.27 4.94 8.21 C 5.17 8.16 5.41 8.13 5.65 8.13 C 6.04 8.09 6.43 8.2 6.74 8.44 C 6.97 8.74 7.09 9.12 7.05 9.5 L 7.05 9.99 C 6.79 9.93 6.54 9.88 6.29 9.84 C 6.05 9.81 5.81 9.79 5.57 9.79 C 4.98 9.76 4.4 9.94 3.94 10.31 C 3.54 10.65 3.32 11.15 3.34 11.68 C 3.31 12.15 3.49 12.62 3.82 12.96 C 4.18 13.29 4.66 13.46 5.15 13.44 C 5.91 13.45 6.63 13.11 7.11 12.51 C 7.18 12.66 7.24 12.79 7.31 12.91 C 7.38 13.02 7.46 13.12 7.55 13.21 C 7.6 13.27 7.67 13.31 7.75 13.31 C 7.81 13.31 7.87 13.29 7.92 13.25 L 8.34 12.97 C 8.41 12.93 8.46 12.86 8.47 12.77 C 8.47 12.72 8.45 12.67 8.42 12.62 C 8.34 12.47 8.26 12.31 8.21 12.14 C 8.15 11.95 8.12 11.75 8.13 11.55 L 8.14 9.37 C 8.2 8.77 8 8.18 7.59 7.74 C 7.17 7.39 6.64 7.19 6.09 7.18 Z M 19.89 7.19 C 19.78 7.19 19.68 7.19 19.57 7.2 C 19.29 7.2 19 7.24 18.73 7.31 C 18.47 7.38 18.23 7.5 18.02 7.66 C 17.82 7.81 17.66 7.99 17.54 8.21 C 17.42 8.43 17.35 8.67 17.36 8.92 C 17.36 9.27 17.48 9.61 17.69 9.89 C 17.97 10.22 18.34 10.46 18.76 10.56 L 19.72 10.87 C 19.97 10.93 20.2 11.05 20.39 11.22 C 20.51 11.35 20.58 11.51 20.57 11.69 C 20.58 11.94 20.45 12.18 20.23 12.31 C 19.93 12.48 19.6 12.56 19.26 12.54 C 18.99 12.54 18.72 12.51 18.46 12.45 C 18.22 12.4 17.98 12.32 17.75 12.22 L 17.59 12.15 C 17.54 12.14 17.5 12.14 17.46 12.15 C 17.36 12.15 17.31 12.22 17.31 12.36 L 17.31 12.69 C 17.31 12.76 17.32 12.82 17.35 12.89 C 17.4 12.97 17.47 13.03 17.56 13.07 C 17.8 13.19 18.06 13.28 18.32 13.34 C 18.66 13.41 19 13.45 19.35 13.45 L 19.33 13.46 C 19.66 13.45 19.98 13.4 20.29 13.3 C 20.55 13.22 20.8 13.09 21.01 12.92 C 21.21 12.77 21.38 12.57 21.49 12.34 C 21.61 12.1 21.67 11.83 21.66 11.56 C 21.67 11.23 21.56 10.9 21.36 10.63 C 21.09 10.32 20.73 10.09 20.33 9.99 L 19.39 9.69 C 19.13 9.61 18.88 9.49 18.67 9.32 C 18.54 9.2 18.47 9.03 18.47 8.85 C 18.46 8.61 18.58 8.38 18.79 8.25 C 19.06 8.11 19.36 8.05 19.67 8.06 C 20.11 8.06 20.55 8.14 20.96 8.32 C 21.04 8.37 21.12 8.4 21.21 8.41 C 21.31 8.41 21.36 8.34 21.36 8.19 L 21.36 7.88 C 21.37 7.8 21.35 7.72 21.31 7.66 C 21.25 7.59 21.18 7.54 21.11 7.49 L 20.83 7.38 L 20.45 7.27 L 20.01 7.2 C 19.97 7.2 19.93 7.19 19.89 7.19 Z M 16.02 7.36 C 15.94 7.35 15.86 7.38 15.79 7.42 C 15.72 7.5 15.68 7.59 15.66 7.69 L 14.51 12.14 L 13.47 7.71 C 13.45 7.61 13.41 7.52 13.34 7.44 C 13.26 7.39 13.17 7.37 13.07 7.38 L 12.54 7.38 C 12.44 7.37 12.35 7.39 12.27 7.44 C 12.2 7.51 12.15 7.61 12.14 7.71 L 11.09 12.14 L 9.97 7.7 C 9.95 7.6 9.91 7.51 9.84 7.44 C 9.76 7.39 9.67 7.36 9.58 7.37 L 8.92 7.37 C 8.81 7.37 8.76 7.43 8.76 7.54 C 8.77 7.63 8.79 7.72 8.82 7.81 L 10.38 12.95 C 10.4 13.05 10.45 13.14 10.52 13.21 C 10.6 13.26 10.69 13.29 10.78 13.28 L 11.36 13.26 C 11.46 13.27 11.55 13.25 11.63 13.19 C 11.7 13.12 11.74 13.03 11.76 12.93 L 12.79 8.64 L 13.82 12.93 C 13.83 13.03 13.88 13.12 13.95 13.19 C 14.03 13.25 14.12 13.27 14.21 13.26 L 14.79 13.26 C 14.88 13.27 14.97 13.25 15.04 13.2 C 15.11 13.13 15.16 13.03 15.18 12.94 L 16.79 7.79 C 16.84 7.72 16.84 7.63 16.84 7.63 C 16.84 7.59 16.84 7.56 16.84 7.52 C 16.84 7.48 16.82 7.43 16.79 7.4 C 16.76 7.37 16.72 7.35 16.67 7.36 L 16.05 7.36 C 16.04 7.36 16.03 7.36 16.02 7.36 Z M 5.65 10.62 C 5.7 10.62 5.75 10.62 5.8 10.62 L 6.43 10.62 C 6.64 10.64 6.85 10.67 7.06 10.71 L 7.07 11.01 C 7.07 11.21 7.05 11.4 7 11.59 C 6.96 11.75 6.88 11.9 6.77 12.01 C 6.61 12.21 6.39 12.36 6.14 12.44 C 5.91 12.52 5.67 12.56 5.43 12.56 C 5.18 12.6 4.93 12.53 4.73 12.37 C 4.55 12.18 4.46 11.92 4.49 11.66 C 4.47 11.36 4.59 11.08 4.81 10.89 C 5.06 10.72 5.35 10.62 5.65 10.62 Z M 21.04 14.72 C 20.34 14.73 19.51 14.89 18.89 15.33 C 18.69 15.46 18.72 15.63 18.94 15.63 C 19.64 15.54 21.21 15.35 21.5 15.71 C 21.78 16.06 21.19 17.54 20.94 18.21 C 20.86 18.41 21.04 18.49 21.21 18.34 C 22.39 17.36 22.72 15.3 22.46 15 C 22.32 14.85 21.74 14.71 21.04 14.72 Z M 2.65 15.1 C 2.5 15.12 2.42 15.3 2.58 15.44 C 5.29 17.89 8.82 19.23 12.48 19.21 C 15.37 19.22 18.2 18.36 20.59 16.74 C 20.95 16.47 20.64 16.07 20.26 16.23 C 17.87 17.24 15.3 17.76 12.71 17.77 C 9.23 17.78 5.82 16.87 2.81 15.14 C 2.75 15.11 2.7 15.1 2.65 15.1 Z M 0 0 L 25 0 L 25 25 L 0 25 Z",
    fill: "#232f3e",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 723,
      height: 1,
      paddingTop: 7,
      marginLeft: 32
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "AWS Cloud")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 19,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "AWS Cloud")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 360 Q 220 360 220 128.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 121.35 L 224.5 130.35 L 220 128.1 L 215.5 130.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 189.5,
    y: 359.5,
    width: 60,
    height: 60,
    xlinkHref: "https://avatars.githubusercontent.com/u/44036562?s=280&v=4",
    preserveAspectRatio: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 32.54 320 C 22.22 320 15 312.79 15 305.12 C 15 295.94 23.62 290 32.67 290 C 41.39 290 50 296.13 50 304.99 C 50 312.93 42.63 320 32.54 320 Z",
    fill: "#0d2636",
    stroke: "none",
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 28.76 316.72 C 28.76 317.36 28.18 317.63 27.33 317.38 C 22.15 315.82 17.17 311.02 17.17 305.02 C 17.17 296.9 25.26 291.79 32.28 291.79 C 41.4 291.79 47.88 298.19 47.88 304.94 C 47.88 310.52 43.69 315.65 37.42 317.45 C 36.71 317.61 36.27 317.29 36.27 316.75 L 36.27 312.85 C 36.27 312.09 35.91 311.29 35.25 310.72 C 37.8 310.47 39.34 309.93 40.52 308.88 C 41.69 307.9 42.21 306.44 42.3 304.65 C 42.37 303.23 41.92 301.84 40.72 300.78 C 41.14 299.91 41.21 298.75 40.58 297.32 C 39.32 297.23 37.88 297.88 36.41 298.66 C 33.83 298.08 31.24 298.01 28.66 298.69 C 27.5 298.05 26.45 297.32 24.45 297.32 C 23.92 298.58 23.84 299.74 24.29 300.76 C 22.86 302.12 22.7 303.46 22.72 304.79 C 22.88 307.36 23.98 308.66 25.2 309.43 C 26.21 310.08 27.63 310.48 29.79 310.75 C 29.21 311.24 28.88 311.83 28.83 312.52 C 27.56 313.01 25.74 313.27 24.49 311.75 C 23.94 310.99 23.18 310.14 21.74 310.14 C 21.5 310.13 21.27 310.21 21.24 310.3 C 21.2 310.4 21.34 310.6 21.5 310.67 C 22.76 311.36 22.96 311.75 23.48 312.69 C 23.95 313.79 24.78 314.21 25.68 314.5 C 26.59 314.78 28.07 314.7 28.76 314.5 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 295,
    width: 80,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 305,
      marginLeft: 85
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 20
    }
  }, "GitHub"))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 309,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "GitHub")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 525 L 194.9 525",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 201.65 525 L 192.65 529.5 L 194.9 525 L 192.65 520.5 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 525,
      marginLeft: 111
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "merge")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 111,
    y: 531,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "merge")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 40.61 535.61 Q 40.6 580 230 580 Q 419.4 580 419.39 545.71",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 419.39 538.96 L 423.9 547.96 L 419.39 545.71 L 414.9 547.96 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 30 540 Q 30 620 335 620 Q 640 620 640 550.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 640 543.35 L 644.5 552.35 L 640 550.1 L 635.5 552.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 525,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "20px"
  }, /*#__PURE__*/React.createElement("text", {
    x: 29.5,
    y: 569.5
  }, "dev"))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 510 Q 220 510 220 430.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 423.35 L 224.5 432.35 L 220 430.1 L 215.5 432.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 235 525 L 404.9 525",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 411.65 525 L 402.65 529.5 L 404.9 525 L 402.65 520.5 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 525,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "20px"
  }, /*#__PURE__*/React.createElement("text", {
    x: 219.5,
    y: 569.5
  }, "dev-public"))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 430 510 Q 430 510 430 430.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 430 423.35 L 434.5 432.35 L 430 430.1 L 425.5 432.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 445 525 L 614.9 525",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 621.65 525 L 612.65 529.5 L 614.9 525 L 612.65 520.5 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 430,
    cy: 525,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "20px"
  }, /*#__PURE__*/React.createElement("text", {
    x: 429.5,
    y: 569.5
  }, "uat"))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 640 510 Q 640 510 640 430.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 640 423.35 L 644.5 432.35 L 640 430.1 L 635.5 432.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 640,
    cy: 525,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "20px"
  }, /*#__PURE__*/React.createElement("text", {
    x: 639.5,
    y: 569.5
  }, "prod"))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 430 360 Q 430 360 430 128.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 430 121.35 L 434.5 130.35 L 430 128.1 L 425.5 130.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 399.5,
    y: 359.5,
    width: 60,
    height: 60,
    xlinkHref: "https://avatars.githubusercontent.com/u/44036562?s=280&v=4",
    preserveAspectRatio: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 640 360 Q 640 360 640 128.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 640 121.35 L 644.5 130.35 L 640 128.1 L 635.5 130.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    x: 609.5,
    y: 359.5,
    width: 60,
    height: 60,
    xlinkHref: "https://avatars.githubusercontent.com/u/44036562?s=280&v=4",
    preserveAspectRatio: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 181 40 L 259 40 L 259 118 L 181 118 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 243.28 82.22 L 243.71 79.21 C 247.66 81.57 247.71 82.55 247.71 82.58 C 247.7 82.58 247.03 83.14 243.28 82.22 Z M 241.12 81.62 C 234.3 79.56 224.8 75.2 220.96 73.39 C 220.96 73.37 220.96 73.36 220.96 73.34 C 220.96 71.86 219.76 70.66 218.28 70.66 C 216.81 70.66 215.61 71.86 215.61 73.34 C 215.61 74.82 216.81 76.02 218.28 76.02 C 218.93 76.02 219.52 75.78 219.98 75.39 C 224.51 77.53 233.93 81.82 240.8 83.85 L 238.08 103.03 C 238.07 103.08 238.07 103.13 238.07 103.18 C 238.07 104.87 230.6 107.97 218.39 107.97 C 206.05 107.97 198.49 104.87 198.49 103.18 C 198.49 103.13 198.49 103.08 198.48 103.03 L 192.81 61.57 C 197.72 64.95 208.29 66.74 218.39 66.74 C 228.48 66.74 239.03 64.96 243.96 61.59 Z M 192.21 57.25 C 192.29 55.78 200.71 50.03 218.39 50.03 C 236.07 50.03 244.5 55.78 244.58 57.25 L 244.58 57.75 C 243.61 61.04 232.69 64.51 218.39 64.51 C 204.07 64.51 193.15 61.02 192.21 57.73 Z M 246.81 57.27 C 246.81 53.41 235.74 47.8 218.39 47.8 C 201.05 47.8 189.98 53.41 189.98 57.27 L 190.08 58.11 L 196.27 103.27 C 196.41 108.32 209.88 110.2 218.39 110.2 C 228.94 110.2 240.15 107.77 240.3 103.27 L 242.97 84.44 C 244.45 84.8 245.68 84.98 246.66 84.98 C 247.98 84.98 248.87 84.66 249.41 84.01 C 249.85 83.48 250.02 82.85 249.89 82.16 C 249.61 80.62 247.77 78.96 244.05 76.83 L 246.69 58.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 125,
      marginLeft: 220
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "dev.privatetutor.plus")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 137,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "dev.privatetu...")))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 391 40 L 469 40 L 469 118 L 391 118 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 453.28 82.22 L 453.71 79.21 C 457.66 81.57 457.71 82.55 457.71 82.58 C 457.7 82.58 457.03 83.14 453.28 82.22 Z M 451.12 81.62 C 444.3 79.56 434.8 75.2 430.96 73.39 C 430.96 73.37 430.96 73.36 430.96 73.34 C 430.96 71.86 429.76 70.66 428.28 70.66 C 426.81 70.66 425.61 71.86 425.61 73.34 C 425.61 74.82 426.81 76.02 428.28 76.02 C 428.93 76.02 429.52 75.78 429.98 75.39 C 434.51 77.53 443.93 81.82 450.8 83.85 L 448.08 103.03 C 448.07 103.08 448.07 103.13 448.07 103.18 C 448.07 104.87 440.6 107.97 428.39 107.97 C 416.05 107.97 408.49 104.87 408.49 103.18 C 408.49 103.13 408.49 103.08 408.48 103.03 L 402.81 61.57 C 407.72 64.95 418.29 66.74 428.39 66.74 C 438.48 66.74 449.03 64.96 453.96 61.59 Z M 402.21 57.25 C 402.29 55.78 410.71 50.03 428.39 50.03 C 446.07 50.03 454.5 55.78 454.58 57.25 L 454.58 57.75 C 453.61 61.04 442.69 64.51 428.39 64.51 C 414.07 64.51 403.15 61.02 402.21 57.73 Z M 456.81 57.27 C 456.81 53.41 445.74 47.8 428.39 47.8 C 411.05 47.8 399.98 53.41 399.98 57.27 L 400.08 58.11 L 406.27 103.27 C 406.41 108.32 419.88 110.2 428.39 110.2 C 438.94 110.2 450.15 107.77 450.3 103.27 L 452.97 84.44 C 454.45 84.8 455.68 84.98 456.66 84.98 C 457.98 84.98 458.87 84.66 459.41 84.01 C 459.85 83.48 460.02 82.85 459.89 82.16 C 459.61 80.62 457.77 78.96 454.05 76.83 L 456.69 58.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 125,
      marginLeft: 430
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "uat.privatetutor.plus")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 137,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "uat.privatetu...")))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 601 40 L 679 40 L 679 118 L 601 118 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 663.28 82.22 L 663.71 79.21 C 667.66 81.57 667.71 82.55 667.71 82.58 C 667.7 82.58 667.03 83.14 663.28 82.22 Z M 661.12 81.62 C 654.3 79.56 644.8 75.2 640.96 73.39 C 640.96 73.37 640.96 73.36 640.96 73.34 C 640.96 71.86 639.76 70.66 638.28 70.66 C 636.81 70.66 635.61 71.86 635.61 73.34 C 635.61 74.82 636.81 76.02 638.28 76.02 C 638.93 76.02 639.52 75.78 639.98 75.39 C 644.51 77.53 653.93 81.82 660.8 83.85 L 658.08 103.03 C 658.07 103.08 658.07 103.13 658.07 103.18 C 658.07 104.87 650.6 107.97 638.39 107.97 C 626.05 107.97 618.49 104.87 618.49 103.18 C 618.49 103.13 618.49 103.08 618.48 103.03 L 612.81 61.57 C 617.72 64.95 628.29 66.74 638.39 66.74 C 648.48 66.74 659.03 64.96 663.96 61.59 Z M 612.21 57.25 C 612.29 55.78 620.71 50.03 638.39 50.03 C 656.07 50.03 664.5 55.78 664.58 57.25 L 664.58 57.75 C 663.61 61.04 652.69 64.51 638.39 64.51 C 624.07 64.51 613.15 61.02 612.21 57.73 Z M 666.81 57.27 C 666.81 53.41 655.74 47.8 638.39 47.8 C 621.05 47.8 609.98 53.41 609.98 57.27 L 610.08 58.11 L 616.27 103.27 C 616.41 108.32 629.88 110.2 638.39 110.2 C 648.94 110.2 660.15 107.77 660.3 103.27 L 662.97 84.44 C 664.45 84.8 665.68 84.98 666.66 84.98 C 667.98 84.98 668.87 84.66 669.41 84.01 C 669.85 83.48 670.02 82.85 669.89 82.16 C 669.61 80.62 667.77 78.96 664.05 76.83 L 666.69 58.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 125,
      marginLeft: 640
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "privatetutor.plus")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 137,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "privatetutor....")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 525,
      marginLeft: 320
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "merge")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 531,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "merge")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 525,
      marginLeft: 520
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "merge")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 531,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "merge")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 574,
      marginLeft: 343
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "merge")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 343,
    y: 580,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "merge")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 614,
      marginLeft: 393
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "merge")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 393,
    y: 620,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "merge"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontEndDevOps);
export default __webpack_public_path__ + "static/media/Front-End-DevOps.33eb0fa0b225305016464d455b43c18e.svg";
export { ForwardRef as ReactComponent };